import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.22_@types+node@20.17.11_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.22_@types+node@20.17.11_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Fira_Code\",\"arguments\":[{\"variable\":\"--font-fira-code\",\"subsets\":[\"latin\"]}],\"variableName\":\"firaCode\"}");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layout/Provider.tsx");
